import React, { FunctionComponent } from 'react'
import { Field, FieldRenderProps, useForm } from 'react-final-form'
import { useIntl } from 'react-intl'

import { useTheme } from 'styled-components/native'

import { InputFieldRFF } from '../../atoms/formElements/InputField'
import { useAnnounceError } from '../../hooks/useAnnounceError'
import { tID } from '../../utils/utils'

export interface FindEmployerInputFieldProps {
  testID?: string
}

const FindEmployerInputFieldRFF: FunctionComponent<FieldRenderProps<string>> = (props) => {
  useAnnounceError(props.meta)

  return <InputFieldRFF {...props} />
}

export const FindEmployerInputField: FunctionComponent<FindEmployerInputFieldProps> = ({ testID }) => {
  const { formatMessage } = useIntl()
  const {
    isAuroraTheme,
    breakpoints: { isMobileSized },
  } = useTheme()
  const form = useForm()

  const handleRequired = (value: string) => {
    if (!value || !/\S/.test(value)) {
      return formatMessage({
        defaultMessage: 'Organization name is required',
        description: 'Error message for required organization field in Find Employer form',
      })
    }
    return ''
  }

  return (
    <Field
      name='FindEmployerInputField'
      inputAccessoryViewID={testID || tID('FindEmployerInputField')}
      label={formatMessage({
        defaultMessage: 'What organization is sponsoring your access to Lyra?',
        description:
          'Input field label where users can enter the organization’s name that sponsors their access to Lyra and be redirected to the organization’s microsite page.',
      })}
      component={FindEmployerInputFieldRFF}
      onSubmitEditing={() => form.submit()}
      validate={handleRequired}
      returnKeyType='done'
      baseInputStyle={{ marginBottom: isMobileSized ? 16 : 26 }}
      labelContainerStyle={isAuroraTheme ? { marginBottom: 16 } : undefined}
    />
  )
}
